// src/utils/userCache.js
let cachedUsers = null;

export const getCachedUsers = () => cachedUsers;
export const setCachedUsers = (users) => {
  cachedUsers = users;
};
export const clearUserCache = () => {
    cachedUsers = null;
  };
  